import loggingAndAnalyticsSetup from './loggingAndAnalyticsSetup';
import loadPolyfills from 'config/polyfills';
import axiosSetup from './axiosSetup';
import setupGoogleAnalytics from './setupGoogleAnalytics';

export default function() {
  loggingAndAnalyticsSetup();
  loadPolyfills();
  axiosSetup();
  setupGoogleAnalytics();
}
